import { BackendType, FrontendType, ObjectType } from '@/models/general';

export type Mail<T extends ObjectType = FrontendType> = {
    attachments: Attachment[];
    id: string;
    bcc: string[];
    cc: string[];
    from: string;
    orderId: string;
    plainText: string;
    replyTo: string;
    sentAt: T extends BackendType ? string : Date;
    html: string;
    subject: string;
    to: string[];
    userId: string;
};

export const convertMailToFrontendType = (mail: Mail<BackendType>): Mail => ({
    ...mail,
    sentAt: new Date(mail.sentAt),
});

export type Attachment = {
    contentType: string;
    data: string;
    filename: string;
};
